/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamSmall = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
        officialName: {
            type: 'string',
            isRequired: true,
        },
        internalName: {
            type: 'string',
        },
        emblemUrl: {
            type: 'string',
            isRequired: true,
        },
        primaryColor: {
            type: 'string',
            isRequired: true,
        },
        secondaryColor: {
            type: 'string',
            isRequired: true,
        },
        outOfCompetition: {
            type: 'boolean',
            isRequired: true,
        },
    },
} as const;
